import {
  FlagPurposeLabel,
  FlagPurposeType,
  LAST_MILESTONE_PACKAGE_BY_PROGRAM_TYPE,
  MilestonePackageRoute,
  MilestoneRouteToMilestoneTypeMap,
  MilestoneType,
  ProgramType,
} from 'types';

export function determineFlagPurposeOptions(
  account: any,
  flagMilestonePackageRoute?: MilestonePackageRoute,
  editMode?: boolean,
): Array<{ value: string; label: string }> {
  const allOptions = Object.entries(FlagPurposeLabel).map(([key, value]) => ({
    value: key,
    label: value as string,
  }));

  const currentMilestonePosition = account?.currentMilestone?.order + 1 || 0;
  const effectiveLastOrder = LAST_MILESTONE_PACKAGE_BY_PROGRAM_TYPE[account?.programType as ProgramType];

  const isCurrentFlagMilestoneRouteLastMilestonePackage = (() => {
    const lastMilestoneType = account?.milestones?.find((m: any) => (m?.order ?? -1) + 1 === effectiveLastOrder)
      ?.type as MilestoneType | undefined;

    if (!flagMilestonePackageRoute || !lastMilestoneType) return false;

    const routeToMilestoneType = MilestoneRouteToMilestoneTypeMap[flagMilestonePackageRoute];

    return routeToMilestoneType === lastMilestoneType;
  })();

  const isAtLastMilestone =
    currentMilestonePosition === effectiveLastOrder && isCurrentFlagMilestoneRouteLastMilestonePackage;

  return allOptions.filter((option) => {
    switch (option.value) {
      case FlagPurposeType.notification:
        return !editMode;
      case FlagPurposeType.stipulation:
        return !isAtLastMilestone;
      default:
        return true;
    }
  });
}
